import React, { useState, useEffect } from 'react'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Badge, Spinner, Input } from 'reactstrap'
import DeleteModal from "components/Common/DeleteModal"
import { SuccessOk } from 'configs/statusCode'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux"
import '../styles.scss'
import BuildingModal from '../BuildingModal'
import { appendFilters } from 'store/adminFilter/actions'


const CardItem = ({ index, itemData, Service,compound_id, changeSelectedUnits, selectedAll, updateHandler, setShouldGetData }) => {
    const saleStatus = itemData.sale_status
    const [deleteModal, setDeleteModal] = useState(false)
    const [item, setItem] = useState({...itemData})
    let selected = itemData.selected
    const [itemStatus, setItemStatus] = useState(false)
    const [status, setStatus] = useState(false)
    const [dropdownOpen, setDropdownOpen] = useState(false)
    const service = new Service
    const toggle = () => setDropdownOpen(prevState => !prevState)
    const AuthData = useSelector(state => state.Auth)
    const filter = useSelector(state => state.adminFilter)
    let path = filter.path || localStorage.getItem('path')
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const [loading, setLoading] = useState(false)
    const [addToBuildingModal, setAddToBuildingModal] = useState(false)
    const toggleBuildingModal = () => setAddToBuildingModal(prevState => !prevState)
    const dispatch =useDispatch()

    useEffect(() => {
        setItemStatus(saleStatus)
    }, [saleStatus])

    useEffect(() => {
        setStatus(item.status)
    }, [item.status])

    useEffect(() => {
        setItem({...item, selected: selectedAll})
        changeSelectedUnits(item.id, selectedAll)
    }, [selectedAll])

    const handleCloseModal = (action, response) => {
        setDeleteModal(false)
        if (action === "delete") {
            setShouldGetData(true)
        }
    }
    const changeSaleStatus = (e) => {
        setLoading(true)
        const value = e.target.checked
        service.toggleSaleStatus(item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                setLoading(false)
                if(itemStatus === "Bought"){
                    setItemStatus("Left")
                } else{
                    setItemStatus("Bought")
                }
                toast.success("Status changed successfully");
                // setShouldGetData(true)
            }
        });
    }
    const changeStatus =() =>{
        service.toggleStatus(item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                toast.success("Status changed successfully");
                setShouldGetData(true)
            }
        });
    }

    return (
        <>
            <tr key={index}>
                <td className='font-size-13'>
                    <Input type='checkbox' checked={item.selected} onChange={(e)=>{
                        setItem({...item, selected: e.target.checked})
                        changeSelectedUnits(item.id, e.target.checked)
                    }}/>
                </td>
                <td className='font-size-13'>{item.id}</td>
                <td className='font-size-13' style={{fontWeight: 700 }}>{item.name.en}</td>
                {/* <td className='font-size-13' style={{ textDecoration: "underLine", fontWeight: 700 }}>{item.compound.name}</td> */}
                {/* <th className="font-size-13">{item.type} </th> */}
                <td className="font-size-13">{item.unit_type_name || '-'} </td>
                <td className='font-size-13'>{toCurrency(item.price)}</td>
                <td className='font-size-13'>{item.size}</td>
                <td className='font-size-13'>{item.bedrooms || '-'}</td>
                <td className='font-size-13 btn-hover' onClick={changeSaleStatus}>
                    {!loading ? <Badge
                        className="font-size-14 p-2"
                        style={{background: itemStatus === 'Bought'? '#50a5f1' : '#e1e9f0', color: itemStatus ==="Bought" ? '#fff' : '#0583f2'}}
                    >{itemStatus}
                    </Badge>  :
                    <div className="p-2">
                        <Spinner size="sm" color="primary"></Spinner>
                    </div>}
                </td>

                <td className='font-size-14 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={status}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                            />
                        </div>
                    </form>
                </td>

                {/* <td className='font-size-13 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                disabled={isExist("compound.edit") ? false:true}

                            />
                        </div>
                    </form>
                </td> */}
                {/* <td className='font-size-16'>{status ? "true" : "false"}</td> */}
                {isExist("compound.edit") || isExist("compound.delete") ?   <td className="removebtnhover">
                    <Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                        <DropdownToggle caret>
                            <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                        </DropdownToggle>
                        <DropdownMenu>
                        {isExist("compound.edit") ?
                         <DropdownItem onClick={()=>{
                            updateHandler()
                            dispatch(appendFilters({addProperty : 'property'}))
                         }}>Edit</DropdownItem>
                         :null}
                        {isExist("compound.add") ?
                         <DropdownItem onClick={()=>{
                            setAddToBuildingModal(true)
                         }}>{path === "PropertiesInBuilding" ? 'Change Building' : 'Add to Building'}</DropdownItem>
                         :null}
                            {isExist("compound.delete") ? 
                            <DropdownItem onClick={() => {
                                setDeleteModal(!deleteModal)
                            }}><span className="text-danger">Remove Property</span></DropdownItem>
                            :null}
                        </DropdownMenu>
                    </Dropdown>
                </td> :null}
            </tr>
            <DeleteModal
                open={deleteModal}
                titleMsg={name.en}
                deletedItem={item}
                modelService={service}
                onCloseModal={(action) => handleCloseModal(action)}
            />
            {addToBuildingModal && <BuildingModal
                        modal={addToBuildingModal}
                        compound_id={compound_id}
                        building_id={filter.building_id}
                        ids={[item.id]}
                        toggle={toggleBuildingModal}
                        setShouldGetData={setShouldGetData}
                        type={filter.path}
                    />}
        </>

    )
}
const toCurrency = (number) => {
    const formatter = new Intl.NumberFormat("en-US");
    return formatter.format(number);
}


export default CardItem